var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxsUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxs-up-arrow.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.40024 10H10.6004C10.6733 9.99977 10.7448 9.97963 10.8071 9.94174C10.8694 9.90386 10.9203 9.84967 10.9541 9.785C10.988 9.72032 11.0036 9.64763 10.9993 9.57473C10.995 9.50183 10.9709 9.43149 10.9297 9.37128L7.32955 4.16199C7.18035 3.946 6.82114 3.946 6.67153 4.16199L3.07143 9.37128C3.02976 9.43136 3.00532 9.50174 3.00078 9.57476C2.99623 9.64778 3.01174 9.72065 3.04564 9.78546C3.07953 9.85027 3.1305 9.90453 3.19302 9.94235C3.25554 9.98018 3.32721 10.0001 3.40024 10Z",
    fill: "#2ED166"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxsUpArrow);
export default __webpack_public_path__ + "static/media/bxs-up-arrow.fd7efa161a0aac29597694312d8bd373.svg";
export { ForwardRef as ReactComponent };